import {defineMessages} from 'react-intl';

export default defineMessages({
  pageTitle: {
    defaultMessage: 'Please enter your coupon code',
    id: 'RedeemPage.PageTitle',
  },
});
